"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MATCHES_MULTIPLE_SLASHES = /\/{2,}/g;
exports.MATCHES_MAYBE_TRAILING_SLASH = /\/?$/;
exports.MATCHES_MAYBE_PROTOCOL = /^(?:(?:[^\/]+?:)?\/{0,2})?/;
exports.DEFAULT_OPTIONS = {
    encode: true,
    decode: true,
    normalize: true,
    queryArrayFormatSeparator: ',',
};
//# sourceMappingURL=constants.js.map